import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import { SkillConfig } from "../config/SkillConfig";
import { CustomConfig } from "../config/CustomConfig";
export class DataManager {
    InitData() {
        this.InitSkill();
        this.tryRoleId = GameData.instance.roleId;
        this.tryPetId = GameData.instance.petId;
        CustomConfig.dataList.forEach(e => {
            if (e.unlock_type == 0) {
                GlobalUnit.dataManager.UnlockLevel(e.level_id);
            }
        });
    }
    InitSkill() {
        if (!this._skillsConfig) {
            this._skillsConfig = {};
            let len = SkillConfig.dataList.length;
            for (let i = 0; i < len; ++i) {
                let config = SkillConfig.dataList[i];
                let pool = this._skillsConfig[config.skill_type];
                if (!pool) {
                    pool = this._skillsConfig[config.skill_type] = [];
                }
                pool.push(config);
            }
        }
        if (!GameData.instance.skills) {
            GameData.instance.skills = {};
            for (let key in this._skillsConfig) {
                GameData.instance.skills[key] = 0;
            }
            GameData.SaveToDisk();
        }
    }
    GetSkillConfig(type) {
        let index = GameData.instance.skills[type];
        return this._skillsConfig[type][index];
    }
    UpgradeSkill(type) {
        GameData.instance.skills[type]++;
        let player = GlobalUnit.game.player;
        switch (type) {
            case 0:
                player.UpgradePlayerYear();
                break;
            case 1:
                player.UpgradePlayerCount();
                break;
            case 2:
                player.UpgradeFireRate();
                break;
            case 3:
                player.UpgradeDamageRate();
                break;
        }
    }
    CheckItemUnlock(type, id) {
        switch (type) {
            case 1:
                return GameData.instance.pets.indexOf(id) != -1;
            case 2:
                return GameData.instance.roleIds.indexOf(id) != -1;
        }
    }
    CheckItemUse(type, id) {
        switch (type) {
            case 1:
                return GameData.instance.petId == id;
            case 2:
                return GameData.instance.roleId == id;
        }
    }
    UpdateProgress(storeId) {
        let pool = GameData.instance.storeProgress;
        if (!pool[storeId]) {
            pool[storeId] = 0;
        }
        return ++pool[storeId];
    }
    GetStoreProgress(storeId) {
        return GameData.instance.storeProgress[storeId] || 0;
    }
    UnlockItem(type, id) {
        switch (type) {
            case 1:
                GameData.instance.pets.push(id);
                GameData.instance.petId = id;
                break;
            case 2:
                GameData.instance.roleIds.push(id);
                GameData.instance.roleId = id;
                break;
        }
        GameData.SaveToDisk();
    }
    UseItem(type, id) {
        switch (type) {
            case 1:
                GameData.instance.petId = id;
                break;
            case 2:
                GameData.instance.roleId = id;
                break;
        }
    }
    UnlockMode(mode) {
        if (GameData.instance.unlockedMode.indexOf(mode) < 0) {
            GameData.instance.unlockedMode.push(mode);
            GameData.SaveToDisk();
        }
    }
    IsModeUnlocked(mode) {
        return GameData.instance.unlockedMode.indexOf(mode) > -1;
    }
    UnlockLevel(lv) {
        if (GameData.instance.unlockedLevels.indexOf(lv) < 0) {
            GameData.instance.unlockedLevels.push(lv);
            GameData.SaveToDisk();
        }
    }
    IsLevelUnlocked(lv) {
        return GameData.instance.unlockedLevels.indexOf(lv) > -1;
    }
}
